/**
 * Template: Customers
 * -----------------------------------------------------------------------------
 * Used to import styles for all customer templates.
 *
 */
import '~async/customers/customers.scss'
import '~async/customers/header/customers-header.scss'
import '~async/customers/navigation/customers-navigation.scss'

import { vueReady } from '~/core/runners'

import CustomersNavigation from '~/components/customers-navigation'
import ShowPassword from '~/components/show-password'

vueReady(() => {
  CustomersNavigation().init()
  ShowPassword().init()
})
